import React from 'react'

export default function Tooltip(props) {
  const { children, tooltipContent, tooltipClasses } = props

  return (
    <>
      {tooltipContent ?
        <div className={`dropdownHover ${tooltipClasses}`}>
          <div className="dropup">
            <span>{children}</span>
            <div className="dropdown-menu p-3 max-height-9 font-weight-500 font-size-14 line-height-normal overflow-auto">{tooltipContent}</div>
          </div>
        </div> :
        <div>{children}</div>
      }
    </>
  )
}